// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/loyalty/viewed_loyalty_credits_given.proto" (package "bianka.event.activity.v2.extension.loyalty", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../../../core/enrichment/organization";
import { TierLevel } from "./common";
import { EventSource } from "./common";
import { Component } from "./common";
import { User } from "../../../../../core/enrichment/user";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.loyalty.ViewedLoyaltyCreditsGiven
 */
export interface ViewedLoyaltyCreditsGiven {
    /**
     * The user who clicked the link
     *
     * @generated from protobuf field: bianka.core.enrichment.User user = 1;
     */
    user?: User;
    /**
     * The clicked component
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.Component component = 2;
     */
    component?: Component;
    /**
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.loyalty.EventSource event_source = 3;
     */
    eventSource?: EventSource;
    /**
     * The loyalty tier of member
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.TierLevel tier_level = 4;
     */
    tierLevel: TierLevel;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 5;
     */
    organization?: Organization;
}
// @generated message type with reflection information, may provide speed optimized methods
class ViewedLoyaltyCreditsGiven$Type extends MessageType<ViewedLoyaltyCreditsGiven> {
    constructor() {
        super("bianka.event.activity.v2.extension.loyalty.ViewedLoyaltyCreditsGiven", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "component", kind: "message", T: () => Component },
            { no: 3, name: "event_source", kind: "enum", opt: true, T: () => ["bianka.event.activity.v2.extension.loyalty.EventSource", EventSource, "EVENT_SOURCE_"] },
            { no: 4, name: "tier_level", kind: "enum", T: () => ["bianka.event.activity.v2.extension.loyalty.TierLevel", TierLevel, "TIER_LEVEL_"] },
            { no: 5, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.loyalty.ViewedLoyaltyCreditsGiven
 */
export const ViewedLoyaltyCreditsGiven = new ViewedLoyaltyCreditsGiven$Type();
